import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Emptiness",
    opening: localizedGenderNode(
      [
      "Today I do not try to fill the emptiness.",
      "I only notice: it is here."
    ],
      [
      "Today I do not try to fill the emptiness.",
      "I only notice: it is here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is the emptiness strongest?",
      "How does the emptiness sound in my mind?",
      "What do I feel in my body?"
    ],
      [
      "When is the emptiness strongest?",
      "How does the emptiness sound in my mind?",
      "What do I feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Emptiness is an experience, not me."
    ],
      [
      "Emptiness is an experience, not me."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I am here with the emptiness\".",
      "one breath + \"I am here with the emptiness\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the moment it begins.",
      "I only notice."
    ],
      [
      "Today I notice the moment it begins.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I sit with myself for a moment.",
      "One breath."
    ],
      [
      "I sit with myself for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens right before the emptiness rises?",
      "Where does it meet me in the day?",
      "What am I trying to avoid?"
    ],
      [
      "What happens right before the emptiness rises?",
      "Where does it meet me in the day?",
      "What am I trying to avoid?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "In the first moment I have a little space."
    ],
      [
      "In the first moment I have a little space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when it starts.",
      "one breath when it starts."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Body Signals",
    opening: localizedGenderNode(
      [
      "Today I listen to my body before the thought.",
      "I stay with myself."
    ],
      [
      "Today I listen to my body before the thought.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does my body feel the emptiness?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ],
      [
      "Where does my body feel the emptiness?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is trying to keep me safe."
    ],
      [
      "My body is trying to keep me safe."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Story vs. Fact",
    opening: localizedGenderNode(
      [
      "Today I separate fact from story.",
      "I do not fight the story."
    ],
      [
      "Today I separate fact from story.",
      "I do not fight the story."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the simple fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ],
      [
      "What is the simple fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not me."
    ],
      [
      "A story is not me."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is a story rising\".",
      "an inner sentence - \"This is a story rising\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "What Gets Drained",
    opening: localizedGenderNode(
      [
      "Today I notice what gets drained from me.",
      "Not to blame."
    ],
      [
      "Today I notice what gets drained from me.",
      "Not to blame."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my feet.",
      "One breath."
    ],
      [
      "I feel my feet.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What usually drains me?",
      "What do I keep doing even without energy?",
      "What do I lack to feel 10% more present?"
    ],
      [
      "What usually drains me?",
      "What do I keep doing even without energy?",
      "What do I lack to feel 10% more present?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing what gets drained is already a start."
    ],
      [
      "Noticing what gets drained is already a start."
    ]
    ),
    action: localizedGenderNode(
      "write one thing that drains me.",
      "write one thing that drains me."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Quiet Voices",
    opening: localizedGenderNode(
      [
      "Today I notice the quiet voices under the emptiness.",
      "I do not push."
    ],
      [
      "Today I notice the quiet voices under the emptiness.",
      "I do not push."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my shoulders a little.",
      "One breath."
    ],
      [
      "I soften my shoulders a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What quiet sentence repeats in me?",
      "What does that sentence ask for?",
      "What does my gentle voice say?"
    ],
      [
      "What quiet sentence repeats in me?",
      "What does that sentence ask for?",
      "What does my gentle voice say?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A quiet voice can be an anchor."
    ],
      [
      "A quiet voice can be an anchor."
    ]
    ),
    action: localizedGenderNode(
      "choose one quiet sentence.",
      "choose one quiet sentence."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A Small Need",
    opening: localizedGenderNode(
      [
      "Today I touch the need under the emptiness.",
      "I do not solve."
    ],
      [
      "Today I touch the need under the emptiness.",
      "I do not solve."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I place a hand on my chest.",
      "One breath."
    ],
      [
      "I place a hand on my chest.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to feel a little more alive?",
      "What in me asks for warmth or closeness?",
      "How does it feel when I give myself a moment?"
    ],
      [
      "What do I need to feel a little more alive?",
      "What in me asks for warmth or closeness?",
      "How does it feel when I give myself a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Behind emptiness there is a request."
    ],
      [
      "Behind emptiness there is a request."
    ]
    ),
    action: localizedGenderNode(
      "write one request to myself.",
      "write one request to myself."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A Small Connection",
    opening: localizedGenderNode(
      [
      "Today I look for a small connection inside me.",
      "Not big, just possible."
    ],
      [
      "Today I look for a small connection inside me.",
      "Not big, just possible."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my back supported.",
      "One breath."
    ],
      [
      "I feel my back supported.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What gives me a sense of connection now?",
      "What word calms me?",
      "What can I give myself for a moment?"
    ],
      [
      "What gives me a sense of connection now?",
      "What word calms me?",
      "What can I give myself for a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small connection is still connection."
    ],
      [
      "A small connection is still connection."
    ]
    ),
    action: localizedGenderNode(
      "one quiet word in my heart.",
      "one quiet word in my heart."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Compassion for Myself",
    opening: localizedGenderNode(
      [
      "Today I speak to myself gently.",
      "Not like a judge."
    ],
      [
      "Today I speak to myself gently.",
      "Not like a judge."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my jaw.",
      "One breath."
    ],
      [
      "I soften my jaw.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What can I forgive myself for?"
    ],
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What can I forgive myself for?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Gentleness does not cancel the emptiness."
    ],
      [
      "Gentleness does not cancel the emptiness."
    ]
    ),
    action: localizedGenderNode(
      "one soft sentence to myself.",
      "one soft sentence to myself."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "An Inner Request",
    opening: localizedGenderNode(
      [
      "Today I give myself one clear request.",
      "Not a demand, just a request."
    ],
      [
      "Today I give myself one clear request.",
      "Not a demand, just a request."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my belly soften a little.",
      "One breath."
    ],
      [
      "I feel my belly soften a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ],
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can help me move."
    ],
      [
      "One request can help me move."
    ]
    ),
    action: localizedGenderNode(
      "write the request in a short sentence.",
      "write the request in a short sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A Gentle Value",
    opening: localizedGenderNode(
      [
      "Today I remind myself of a small value that holds me.",
      "Not big."
    ],
      [
      "Today I remind myself of a small value that holds me.",
      "Not big."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice a calmer face.",
      "One breath."
    ],
      [
      "I notice a calmer face.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small value matters to me now?",
      "How does that value look in a normal day?",
      "What small inner step honors it?"
    ],
      [
      "What small value matters to me now?",
      "How does that value look in a normal day?",
      "What small inner step honors it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small value gives me direction."
    ],
      [
      "A small value gives me direction."
    ]
    ),
    action: localizedGenderNode(
      "choose one value and repeat it in my heart.",
      "choose one value and repeat it in my heart."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "How I Am With Myself",
    opening: localizedGenderNode(
      [
      "Today I check how I treat myself.",
      "I do not judge."
    ],
      [
      "Today I check how I treat myself.",
      "I do not judge."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I give myself half a minute of quiet.",
      "One breath."
    ],
      [
      "I give myself half a minute of quiet.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I pressure myself?",
      "Where can I soften a little?",
      "How do I want to speak to myself in the future?"
    ],
      [
      "When do I pressure myself?",
      "Where can I soften a little?",
      "How do I want to speak to myself in the future?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "How I am with me matters."
    ],
      [
      "How I am with me matters."
    ]
    ),
    action: localizedGenderNode(
      "one sentence of respect to myself.",
      "one sentence of respect to myself."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Change",
    opening: localizedGenderNode(
      [
      "Today I choose a small change I can hold.",
      "Not a revolution."
    ],
      [
      "Today I choose a small change I can hold.",
      "Not a revolution."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my body steady for a moment.",
      "One breath."
    ],
      [
      "I feel my body steady for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small change could help me today?",
      "How would it look in practice?",
      "What am I willing to try once?"
    ],
      [
      "What small change could help me today?",
      "How would it look in practice?",
      "What am I willing to try once?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Small enough is enough."
    ],
      [
      "Small enough is enough."
    ]
    ),
    action: localizedGenderNode(
      "one small step for myself.",
      "one small step for myself."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I close gently.",
      "I choose a sentence that brings me back."
    ],
      [
      "Today I close gently.",
      "I choose a sentence that brings me back."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel air coming in and out.",
      "One breath."
    ],
      [
      "I feel air coming in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this emptiness?",
      "What is the earliest sign it is rising?",
      "What sentence brings me back to the moment before?"
    ],
      [
      "What did I learn about this emptiness?",
      "What is the earliest sign it is rising?",
      "What sentence brings me back to the moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I choose presence before reaction."
    ],
      [
      "I choose presence before reaction."
    ]
    ),
    action: localizedGenderNode(
      "one breath and my return sentence.",
      "one breath and my return sentence."
    ),
  },
].map(buildNormalizedDay);

export const feelingOfInnerEmptinessIHaveNoEnergyForAnythingBlueprintEn = buildNormalizedPilotBlueprint({
  id: "feeling_of_inner_emptiness_i_have_no_energy_for_anything_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "feeling_of_inner_emptiness_i_have_no_energy_for_anything",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "תחושת ריק פנימי (אין לי אנרגיה לכלום)",
    en: "Feeling of inner emptiness (I have no energy for anything)",
    es: "Sensación de vacío interior (No tengo energía para nada)",
  },
  days,
});

export default feelingOfInnerEmptinessIHaveNoEnergyForAnythingBlueprintEn;
